import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice";
import NotificationEmailList from "./NotificationEmailList";
import EditNotificationEmail from "./EditNotificationEmail";

const NotificationEmailListWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Notification Emails",
          url: "/admin/notification-emails",
          home: "/admin/dashboard",
        },
      ])
    );
  }, [dispatch]);

  return (
    <NotificationEmailList
      onEditTemplate={(id) => navigate(`/admin/notification-emails/edit/${id}`)}
    />
  );
};

const EditNotificationEmailWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Notification Emails",
          url: "/admin/notification-emails",
          home: "/admin/dashboard",
        },
        { label: "Edit Notification" },
      ])
    );
  }, [dispatch]);

  return (
    <EditNotificationEmail
      templateId={id}
      onBack={() => navigate("/admin/notification-emails")}
    />
  );
};

const NotificationEmails = () => {
  return (
    <div className="py-2">
      <Routes>
        <Route path="" element={<NotificationEmailListWrapper />} />
        <Route path="edit/:id" element={<EditNotificationEmailWrapper />} />
      </Routes>
    </div>
  );
};

export default NotificationEmails;
